import React from 'react';
import { toastr } from 'react-redux-toastr';
import { MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { logout } from '../../utils/helpers/store';

class Logout extends React.Component {

  handleLogout() {
    logout();
    toastr.success('Successfully logged out!');
  }
  
  render() {
    return (
      <MenuItem 
        href='javascript:void(0);' 
        onClick={this.handleLogout.bind(this)}
      >
        Logout
      </MenuItem>
    );
  }
}

export default connect()(Logout);
